import React, { useState, useEffect } from 'react';
import { PDFViewSDKClient } from './pdfViewSDKClient.js';
import { PDF_OPTIONS, PDF_STATUS, PDF_OPTIONS_TO_EMBED_PROPERTIES, RICOS_LOCALE_TO_ADOBE, ADOBE_EVENT_TO_PDF_STATUS } from './pdfConsts.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import classnames from 'classnames';

var css_248z = ".zNQfQ{height:100%;overflow:hidden;width:100%}[dir] .zNQfQ{border:0}.JVdcP{display:none}.PHFqv{height:800px}@media only screen and (max-width:640px){[data-query=media] .PHFqv{height:300px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .PHFqv{height:300px}}}@container (width < 640px){[data-query=container] .PHFqv{height:300px}}";
var styles = {"iframe":"zNQfQ","not_ready":"JVdcP","pdf_viewer":"PHFqv"};
styleInject(css_248z);

function setAdobeSDKScript(scope) {
  const element = scope.document.createElement("script");
  element.setAttribute("id", "ricos-adobe-pdf-view-sdk");
  element.setAttribute("src", "https://documentcloud.adobe.com/view-sdk/main.js");
  scope.document.getElementsByTagName("body")[0].appendChild(element);
}
function PDFViewer(props) {
  const {
    status,
    setStatus,
    fileData,
    config: { clientId, locale = "en" },
    pdfSettings
  } = props;
  const [divId, setDivId] = useState(void 0);
  if (!divId) {
    setDivId(`ricos-pdf-viewer-${Math.floor(Math.random() * 1e4)}`);
  }
  const {
    viewMode = PDF_OPTIONS.NONE,
    disableDownload = false,
    disablePrint = false
  } = pdfSettings || {};
  const handleError = (error) => {
    console.log(error);
    setStatus(PDF_STATUS.ERROR);
  };
  const eventsHandler = (event) => {
    const newStatus = ADOBE_EVENT_TO_PDF_STATUS[event];
    if (newStatus && newStatus !== status) {
      setStatus(newStatus);
    }
  };
  useEffect(() => {
    const pdfStatus = viewMode !== PDF_OPTIONS.NONE ? PDF_STATUS.PENDING : PDF_STATUS.NONE;
    status !== pdfStatus && setStatus(pdfStatus);
  }, [
    props.pdfSettings.viewMode,
    props.pdfSettings.disableDownload,
    props.pdfSettings.disablePrint
  ]);
  useEffect(() => {
    if (!window.document.getElementById("ricos-adobe-pdf-view-sdk")) {
      setAdobeSDKScript(window);
    } else if (status === PDF_STATUS.PENDING) {
      const SDKClient = new PDFViewSDKClient(window);
      SDKClient.ready().then(() => {
        const viewerConfig = {
          embedMode: PDF_OPTIONS_TO_EMBED_PROPERTIES[viewMode],
          showDownloadPDF: !disableDownload,
          showPrintPDF: !disablePrint
        };
        const properties = { clientId, divId, locale: RICOS_LOCALE_TO_ADOBE[locale] };
        SDKClient.previewFileWithURL(properties, fileData, viewerConfig).then(() => {
          SDKClient.registerEventsHandler(eventsHandler);
        }).catch(handleError);
      }).catch(handleError);
    }
  });
  const style = classnames(styles.pdf_viewer, { [styles.not_ready]: status !== PDF_STATUS.READY });
  return /* @__PURE__ */ React.createElement("div", { id: divId, className: style });
}

export { PDFViewer };
//# sourceMappingURL=pdfViewer.js.map
